/**
 * The little markup the legal texts in the message catalog use: `**bold**` and `[text](href)`.
 * Parsed here instead of rendered as HTML, so a text can never bring in markup of its own.
 */
export type InlinePart =
  | { type: 'text'; text: string }
  | { type: 'bold'; text: string }
  | { type: 'link'; text: string; href: string; external: boolean }

const TOKEN = /\*\*(.+?)\*\*|\[([^\]]+)\]\(([^)\s]+)\)/g

/** Only addresses a text may link to: a page here, a mail address or a secure web address. */
export function isSafeHref(href: string): boolean {
  return /^\/(?!\/)/.test(href) || /^mailto:[^\s@]+@[^\s@]+$/.test(href) || /^https:\/\//.test(href)
}

export function parseInline(source: string): InlinePart[] {
  const parts: InlinePart[] = []
  let last = 0
  for (const match of source.matchAll(TOKEN)) {
    const index = match.index ?? 0
    if (index > last) parts.push({ type: 'text', text: source.slice(last, index) })
    const [whole, bold, label, href] = match
    if (bold !== undefined) {
      parts.push({ type: 'bold', text: bold })
    } else if (label !== undefined && href !== undefined && isSafeHref(href)) {
      parts.push({ type: 'link', text: label, href, external: !href.startsWith('/') })
    } else {
      // A link that is not allowed stays visible as plain text
      parts.push({ type: 'text', text: whole })
    }
    last = index + whole.length
  }
  if (last < source.length) parts.push({ type: 'text', text: source.slice(last) })
  return parts
}
